<!--

  This example requires some changes to your config:



  ```

  // tailwind.config.js

  module.exports = {

    // ...

    plugins: [

      // ...

      require('@tailwindcss/aspect-ratio'),

    ],

  }

  ```

-->

<template>
    <div class="bg-white block ts:hidden">
        <!-- Mobile menu -->
        <TransitionRoot as="template" :show="open">
            <Dialog as="div" class="relative z-80 lg:hidden" @close="open = false">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-black bg-opacity-25" />
                </TransitionChild>
                <div class="fixed inset-0 z-40 flex">
                    <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
                        <DialogPanel class="relative flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl">
                            <div class="flex justify-end px-4 pt-5">
                                <ul class="flex w-[90%] justify-around">
                                    <!--                                    <li class="text-sm md:text-base relative" @click="closeAfterSecond">-->
                                    <!--                                        <Link href="/istek-listem" class="flex flex-col justify-center items-center">-->
                                    <!--                                            <svg class="w-6 h-6 stroke-[#231f20] overflow-visible" viewBox="0 0 30.669 28.092">-->
                                    <!--                                                <g id="heart" transform="translate(0 -1.511)" fill="none">-->
                                    <!--                                                    <path-->
                                    <!--                                                        d="M30.071,6.622A13.219,13.219,0,0,1,27.842,18.6,33.873,33.873,0,0,1,22.3,24.456c-1.823,1.7-5.9,5.054-6.983,5.147-.956-.182-2.028-1.263-2.787-1.82-4.264-3.24-8.853-7.181-11.18-11.49C-.6,12.156-.6,7.039,2.433,3.867a8.977,8.977,0,0,1,12.885.853A8.726,8.726,0,0,1,18.3,2.245a8.977,8.977,0,0,1,11.77,4.377Z"-->
                                    <!--                                                        stroke="none"-->
                                    <!--                                                    />-->
                                    <!--                                                    <path-->
                                    <!--                                                        d="M 22.02387619018555 4.511138916015625 C 21.19887924194336 4.511205673217773 20.36529541015625 4.668869018554688 19.54391098022461 4.980022430419922 C 18.81119155883789 5.373607635498047 18.20499801635742 5.888843536376953 17.69393539428711 6.551767349243164 L 15.37918663024902 9.55436897277832 L 12.98918724060059 6.611328125 C 11.93668746948242 5.315288543701172 10.24892616271973 4.541538238525391 8.474416732788086 4.541547775268555 C 7.442102432250977 4.541547775268555 5.927898406982422 4.800741195678711 4.52613639831543 6.020847320556641 C 3.402303695678711 7.246023178100586 3.083917617797852 8.801969528198242 3.016265869140625 9.90241813659668 C 2.916469573974609 11.52574920654297 3.276287078857422 13.31153869628906 4.030189514160156 14.94011974334717 C 4.942806243896484 16.60567092895508 6.383369445800781 18.40690231323242 8.313325881958008 20.29546737670898 C 9.916957855224609 21.86470985412598 11.82877540588379 23.48118019104004 14.32891082763672 25.38162803649902 C 14.57612991333008 25.56426811218262 14.81914901733398 25.76386070251465 15.05441665649414 25.95709800720215 C 15.1480712890625 26.03402137756348 15.26153087615967 26.12721252441406 15.37966251373291 26.22183418273926 C 16.63759994506836 25.36079597473145 18.77116775512695 23.64326858520508 20.25698661804199 22.26020812988281 L 20.30599594116211 22.2145881652832 L 20.35699653625488 22.17119789123535 C 22.4555778503418 20.38569831848145 24.10916709899902 18.6432991027832 25.41224670410156 16.84445953369141 L 25.43560600280762 16.81265830993652 C 27.5122241973877 14.02390670776367 28.17683982849121 10.72176933288574 27.27249336242676 7.72297477722168 C 26.7924976348877 6.758964538574219 26.07523345947266 5.959152221679688 25.18952560424805 5.402528762817383 C 24.26146697998047 4.819278717041016 23.16680717468262 4.511037826538086 22.02387619018555 4.511138916015625 M 22.02363014221191 1.511137008666992 C 25.47772216796875 1.510845184326172 28.58621597290039 3.41154670715332 30.07120704650879 6.62156867980957 L 30.07119750976562 6.62156867980957 C 31.46405601501465 10.92536735534668 30.29865646362305 15.30498790740967 27.84177589416504 18.60439872741699 C 26.22061729431152 20.84233856201172 24.28254699707031 22.77018737792969 22.30101776123047 24.45609855651855 C 20.47795677185059 26.15307807922363 16.39905548095703 29.51041793823242 15.31799697875977 29.60327911376953 C 14.36215591430664 29.42096900939941 13.28961753845215 28.33990859985352 12.53142738342285 27.78361892700195 C 8.267665863037109 24.54384803771973 3.678485870361328 20.60295867919922 1.351097106933594 16.29318809509277 C -0.5997524261474609 12.15636825561523 -0.6031627655029297 7.038997650146484 2.433006286621094 3.867378234863281 C 6.3704833984375 0.318359375 12.3065242767334 1.011802673339844 15.31799697875977 4.720129013061523 C 16.12644577026367 3.671438217163086 17.12146759033203 2.845949172973633 18.30135726928711 2.244508743286133 C 19.5473575592041 1.74708366394043 20.80727195739746 1.511240005493164 22.02363014221191 1.511137008666992 Z"-->
                                    <!--                                                        stroke="none"-->
                                    <!--                                                        fill="#231f20"-->
                                    <!--                                                    />-->
                                    <!--                                                </g>-->
                                    <!--                                            </svg>-->
                                    <!--                                            <span class="flex items-center justify-center font-santralextrabold text-xs text-white bg-kbgreen rounded-full absolute right-1 w-4 h-4 font-normal bottom-5 right-2 text-center leading-none">-->
                                    <!--                                                {{ wishlist }}-->
                                    <!--                                            </span>-->
                                    <!--                                            <span class="mt-1">Listem</span>-->
                                    <!--                                        </Link>-->
                                    <!--                                    </li>-->
                                    <!--                                    <li class="text-sm md:text-base flex flex-col justify-center items-center" @click="closeAfterSecond" v-if="auth.isUserLoggedIn">-->
                                    <!--                                        <Link href="/profili-duzenle">-->
                                    <!--                                            <div class="flex flex-col justify-center items-center" @click="isProfileMenu = true">-->
                                    <!--                                                <div class="font-santralextrabold text-3xs leading-none text-kbgreen w-6 h-6 border-2 rounded-full border-black flex justify-center items-center">-->
                                    <!--                                                    {{-->
                                    <!--                                                        auth.user?.full_name-->
                                    <!--                                                            .split(" ")-->
                                    <!--                                                            .map((n) => n[0])-->
                                    <!--                                                            .join("")-->
                                    <!--                                                    }}-->
                                    <!--                                                </div>-->
                                    <!--                                                <span class="mt-1 text-sm">Hesabım</span>-->
                                    <!--                                            </div>-->
                                    <!--                                        </Link>-->
                                    <!--                                    </li>-->
                                    <li class="flex flex-col justify-center items-center" @click="closeAfterSecond" v-if="!auth.isUserLoggedIn">
                                        <Link :href="`/giris-yap`" class="flex">
                                            <svg class="w-6 h-6 stroke-[#231f20] overflow-visible" viewBox="0 0 34 34">
                                                <g id="Ellipse_138" data-name="Ellipse 138" fill="none" stroke="#231f20" stroke-width="3">
                                                    <circle cx="17" cy="17" r="17" stroke="none" />
                                                    <circle cx="17" cy="17" r="15.5" fill="none" />
                                                </g>
                                            </svg>
                                        </Link>
                                        <Link :href="`/giris-yap`" class="flex">
                                            <span class="text-sm mt-1">Giriş/Üye Ol</span>
                                        </Link>
                                    </li>
                                </ul>

                                <button type="button" class="-m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400" @click="open = false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z" fill="#000000" />
                                    </svg>
                                </button>
                            </div>
                            <!-- Links -->
                            <TabGroup as="div" class="mt-2">
                                <div class="border-b border-gray-200">
                                    <TabList class="-mb-px flex space-x-8 px-4">
                                        <Tab as="template" v-for="category in navigation.categories" :key="category.name" v-slot="{ selected }">
                                            <button v-show="auth.isUserLoggedIn == category.islogged" :class="[selected ? 'border-kbgreen text-kbgreen' : 'border-transparent text-gray-900', 'flex-1 whitespace-nowrap border-b-2 pb-2 px-1 text-base font-medium']">
                                                {{ category.name }}
                                            </button>
                                        </Tab>
                                    </TabList>
                                </div>
                                <TabPanels as="template">
                                    <TabPanel v-for="category in navigation.categories" :key="category.name" class="space-y-0 px-4 pt-4">
                                        <div v-for="(column, columnIdx) in category.sections" :key="columnIdx" class="space-y-2">
                                            <div v-for="section in column" :key="section.name" class="mt-4">
                                                <Link :href="`${section.href}`" @click="closeAfterSecond" :id="`${category.id}-${section.id}-heading-mobile`" class="font-medium text-gray-900">{{ section.name }}</Link>
                                                <ul role="list" :aria-labelledby="`${category.id}-${section.id}-heading-mobile`" class="flex flex-col space-y-1">
                                                    <li v-for="item in section.items" :key="item.name" class="flow-root ml-4">
                                                        <Link :href="item.href" @click="closeAfterSecond" class="-m-2 block p-2 text-gray-500">{{ item.name }}</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <div class="mt-3 p-4 border-t-2 border-bordergray">
                                        <ul class="flex flex-col text-xl leading-6.5 font-medium">
                                            <li class="p-0 m-0 mb-2 text-base text-left text-gray-900 box-border whitespace-no-wrap">
                                                <Link href="/nasil-calisir" @click="closeAfterSecond">Nasıl Çalışır?</Link>
                                            </li>
                                            <li class="p-0 m-0 mb-2 text-base text-left text-gray-900 box-border whitespace-no-wrap">
                                                <Link href="/hakkimizda" @click="closeAfterSecond">Hakkımızda</Link>
                                            </li>
                                            <!--                                            <li class="p-0 m-0 mb-2 text-base text-left text-gray-900 box-border whitespace-no-wrap">-->
                                            <!--                                                <a href="">İndirimli Ürünler</a>-->
                                            <!--                                            </li>-->
                                            <li class="">
                                                <a target="_blank" href="https://kiralabunu.com/">
                                                    <div class="bg-white rounded-xl flex items-center">
                                                        <img src="../../../images/cropped-ikon-192x192.png" class="max-w-[30px]" alt="" />
                                                        <span class="text-[#70d44b] text-sm ml-1"> KİRALABUNU</span>
                                                        <!--                                        <span class="ml-1 whitespace-nowrap hover:text-kbgreen text-xs">KİRALA</span>-->
                                                        <!--                                        <span class="text-[#ff64cf]">İ</span>-->
                                                        <!--                                        <span class="text-[#61ba3f]">N</span>-->
                                                        <!--                                        <span class="text-[#8854d0]">İ</span>-->
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="auth.isUserLoggedIn" class="flex items-center mt-3 border-t-2 border-bordergray p-4">
                                        <Link href="/cikis-yap">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.401" height="25.546" viewBox="0 0 22.401 25.546">
                                                <g id="noun-exit-119208" transform="translate(-128.547 -26.727)">
                                                    <path
                                                        id="Path_3738"
                                                        data-name="Path 3738"
                                                        d="M130.729,212.969H141.32a.642.642,0,0,0,0-1.284H130.729l1.861-1.861a.635.635,0,1,0-.9-.9l-2.953,2.953c-.064.064-.128.128-.128.192a.545.545,0,0,0,0,.513c.064.064.064.128.128.192l2.953,2.953a.621.621,0,0,0,.9,0,.62.62,0,0,0,0-.9Z"
                                                        transform="translate(0 -172.827)"
                                                        fill="#231f20"
                                                    />
                                                    <path
                                                        id="Path_3739"
                                                        data-name="Path 3739"
                                                        d="M263.757,26.727h-9.885a3.15,3.15,0,0,0-3.145,3.145v5.841a.642.642,0,0,0,1.284,0V29.872a1.863,1.863,0,0,1,1.861-1.861h9.949a1.863,1.863,0,0,1,1.861,1.861V49.128a1.863,1.863,0,0,1-1.861,1.861h-9.949a1.863,1.863,0,0,1-1.861-1.861v-5.52a.642.642,0,0,0-1.284,0v5.52a3.15,3.15,0,0,0,3.145,3.145h9.949a3.15,3.15,0,0,0,3.145-3.145V29.872a3.165,3.165,0,0,0-3.209-3.145Z"
                                                        transform="translate(-116.018 0)"
                                                        fill="#231f20"
                                                    />
                                                </g>
                                            </svg>
                                        </Link>
                                        <Link href="/cikis-yap" class="ml-3 whitespace-nowrap text-base font-bold">Çıkış Yap</Link>
                                    </div>
                                </TabPanels>
                            </TabGroup>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>
        <header class="relative bg-white">
            <nav aria-label="Top" class="mx-auto max-w-7xl">
                <div class="border-b border-gray-200">
                    <div class="flex h-16 items-center justify-between">
                        <div class="flex items-center lg:hidden">
                            <button type="button" class="-ml-2 rounded-md bg-white p-2 text-gray-400" @click="open = true">
                                <span class="sr-only">Open menu</span>
                                <svg id="menu-right" class="mx-2 md:mx-0" xmlns="http://www.w3.org/2000/svg" width="32.216" height="22.55" viewBox="0 0 32.216 22.55">
                                    <path id="Path_3735" data-name="Path 3735" d="M18,27.118a1.6,1.6,0,0,0,1.6,1.6H32.5a1.6,1.6,0,0,0,0-3.205H19.6a1.6,1.6,0,0,0-1.6,1.6Z" transform="translate(-18 -6.17)" fill="#ff6c37" />
                                    <path id="Path_3736" data-name="Path 3736" d="M3,18.11a1.6,1.6,0,0,0,1.6,1.6h29.01a1.6,1.6,0,1,0,0-3.205H4.6a1.6,1.6,0,0,0-1.6,1.6Z" transform="translate(-2.999 -6.835)" fill="#ff6c37" />
                                    <path id="Path_3737" data-name="Path 3737" d="M13.6,10.705a1.6,1.6,0,0,1,0-3.205H32.948a1.6,1.6,0,0,1,0,3.205H13.6Z" transform="translate(-11.999 -7.5)" fill="#ff6c37" />
                                </svg>
                            </button>
                        </div>
                        <div class="flex items-center justify-between">
                            <div class="mr-4">
                                <h1>
                                    <Link href="/"><img class="w-11/12 mx-auto max-h-16 md:max-h-14" :id="this.$inertia.page.url" :src="logoUrl" alt="" /></Link>
                                </h1>
                            </div>
                            <div class="hidden lg:block ml-12 mb-1">
                                <ul class="flex space-x-3 ts:space-x-8 text-xl leading-6.5 font-medium">
                                    <li class="p-0 m-0 text-lg text-left text-gray-900 box-border whitespace-no-wrap hover:text-checkoutgray">
                                        <Link href="/nasil-calisir" @click="closeAfterSecond">Nasıl Çalışır?</Link>
                                    </li>
                                    <!--                            <li><svg viewBox="0 0 1 18.297" class="h-full"><path class="stroke-neutral-400" d="M 0 0 L 0 18.296875"></path></svg></li>-->
                                    <li class="p-0 m-0 text-lg text-left text-gray-900 box-border whitespace-no-wrap hover:text-checkoutgray">
                                        <Link href="/hakkimizda" @click="closeAfterSecond">Hakkımızda</Link>
                                    </li>
                                    <!--                                    <li><svg viewBox="0 0 1 18.297" class="h-full"><path class="stroke-neutral-400" d="M 0 0 L 0 18.296875"></path></svg></li>-->
                                    <li class="p-0 m-0 text-lg text-left text-gray-900 box-border whitespace-no-wrap hover:text-checkoutgray">
                                        <Link href="/indirimli-urunler">İndirimli Ürünler</Link>
                                    </li>
                                    <!--                                    <li class="p-0 m-0 text-lg text-left text-gray-900 box-border whitespace-no-wrap hover:text-checkoutgray">-->
                                    <!--                                        <Link href="/tags/1tl">1 TL</Link>-->
                                    <!--                                    </li>-->
                                </ul>
                            </div>
                        </div>
                        <div class="flex items-center">
                            <ul class="flex space-x-2">
                                <li class="text-sm md:text-base relative">
                                    <Link href="/sepetim" class="flex">
                                        <span class="hidden md:block">Sepetim</span>
                                        <span class="font-santralextrabold text-xs lg:text-2xs 2xl:text-xs text-white bg-kbgreen rounded-full absolute w-4 h-4 font-normal -bottom-1 -right-1 flex justify-center items-center leading-none">{{ cart }}</span>
                                        <svg class="w-6 h-6 ml-1 stroke-[#231f20] overflow-visible" viewBox="0 0 30.324 31.234">
                                            <g id="Group_3491" data-name="Group 3491" transform="translate(1.51 1.5)">
                                                <path
                                                    id="Path_2958"
                                                    data-name="Path 2958"
                                                    d="M212.736,218.3H199.28c-2.21,0-4.076-1.109-4.357-2.59l-2.53-13.314c-.337-1.774,1.709-3.345,4.357-3.345h18.515c2.648,0,4.695,1.571,4.358,3.345l-2.53,13.314C216.812,217.194,214.946,218.3,212.736,218.3Z"
                                                    transform="translate(-192.356 -190.068)"
                                                    fill="none"
                                                    stroke="#231f20"
                                                    stroke-miterlimit="10"
                                                    stroke-width="3"
                                                />
                                                <path id="Path_2959" data-name="Path 2959" d="M202.477,192.194l5.167-7.892c.942-1.439,2.268-1.46,3.222-.052l5.381,7.944" transform="translate(-195.558 -183.208)" fill="none" stroke="#231f20" stroke-miterlimit="10" stroke-width="3" />
                                            </g>
                                        </svg>
                                    </Link>
                                </li>
                                <li class="text-sm md:text-base hidden lg:block min-w-[130px]" v-if="!auth.isUserLoggedIn">
                                    <Link :href="`/giris-yap`" class="flex">
                                        Giriş/Üye Ol
                                        <svg class="w-4 md:w-6 h-4 md:h-6 ml-1 stroke-[#231f20] overflow-visible" viewBox="0 0 34 34">
                                            <g id="Ellipse_138" data-name="Ellipse 138" fill="none" stroke="#231f20" stroke-width="3">
                                                <circle cx="17" cy="17" r="17" stroke="none" />
                                                <circle cx="17" cy="17" r="15.5" fill="none" />
                                            </g>
                                        </svg>
                                    </Link>
                                </li>
                                <li class="text-sm md:text-base hidden lg:block relative" v-if="auth.isUserLoggedIn">
                                    <Link href="/profili-duzenle" class="flex">
                                        Hesabım
                                        <div class="font-santralextrabold text-xs leading-none text-kbgreen w-7 h-7 border-2 rounded-full border-black flex justify-center leading-none items-center ml-1">
                                            {{
                                                auth.user?.full_name
                                                    .split(" ")
                                                    .map((n) => n[0])
                                                    .join("")
                                            }}
                                        </div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <!-- Flyout menus -->
                        <!--                        <PopoverGroup class="hidden lg:block lg:flex-1 lg:self-stretch">-->
                        <!--                            <div class="flex h-full space-x-8">-->
                        <!--                                <Popover v-for="category in navigation.categories" :key="category.name" class="flex"-->
                        <!--                                         v-slot="{ open }">-->
                        <!--                                    <div class="relative flex">-->
                        <!--                                        <PopoverButton-->
                        <!--                                            :class="[open ? 'text-kbgreen' : 'text-gray-700 hover:text-gray-800', 'relative z-10 flex items-center justify-center text-sm font-medium transition-colors duration-200 ease-out']">-->
                        <!--                                            {{ category.name }}-->
                        <!--                                            <span-->
                        <!--                                                :class="[open ? 'bg-kbgreen' : '', 'absolute inset-x-0 bottom-0 h-0.5 transition-colors duration-200 ease-out sm:mt-5 sm:translate-y-px sm:transform']"-->
                        <!--                                                aria-hidden="true" />-->
                        <!--                                        </PopoverButton>-->
                        <!--                                    </div>-->
                        <!--                                    <transition enter-active-class="transition ease-out duration-200"-->
                        <!--                                                enter-from-class="opacity-0" enter-to-class="opacity-100"-->
                        <!--                                                leave-active-class="transition ease-in duration-150"-->
                        <!--                                                leave-from-class="opacity-100" leave-to-class="opacity-0">-->
                        <!--                                        <PopoverPanel class="absolute inset-x-0 top-full z-80">-->
                        <!--                                            &lt;!&ndash; Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow &ndash;&gt;-->
                        <!--                                            <div class="absolute inset-0 top-1/2 bg-white shadow" aria-hidden="true" />-->
                        <!--                                            <div class="relative bg-white">-->
                        <!--                                                <div class="mx-auto max-w-7xl px-8 pt-6">-->

                        <!--                                                    <div-->
                        <!--                                                        class="grid grid-cols-4 gap-y-10 gap-x-8 text-sm text-gray-500">-->

                        <!--                                                        <div v-for="(column, columnIdx) in category.sections"-->
                        <!--                                                             :key="columnIdx" class="space-y-5">-->
                        <!--                                                            <div v-for="section in column" :key="section.name">-->
                        <!--                                                                <p :id="`${category.id}-${section.id}-heading`"-->
                        <!--                                                                   class="text-base text-black hover:text-gray-600">-->
                        <!--                                                                    {{ section.name }}-->
                        <!--                                                                </p>-->
                        <!--                                                                <ul role="list"-->
                        <!--                                                                    :aria-labelledby="`${category.id}-${section.id}-heading`"-->
                        <!--                                                                    class="mt-4 space-y-2">-->
                        <!--                                                                    <li v-for="item in section.items"-->
                        <!--                                                                        :key="item.name" class="flex">-->
                        <!--                                                                        <a :href="item.href"-->
                        <!--                                                                           class="text-gray-600 hover:text-gray-400 text-sm">{{ item.name-->
                        <!--                                                                            }}</a>-->
                        <!--                                                                    </li>-->
                        <!--                                                                </ul>-->
                        <!--                                                            </div>-->
                        <!--                                                        </div>-->
                        <!--                                                        <div class="h-[462px] hidden ts:block">-->
                        <!--                                                            <a href="/ara?term=s23">-->
                        <!--                                                                <img src="../../../images/category-image.png" alt=""-->
                        <!--                                                                     class="object-contain" />-->
                        <!--                                                            </a>-->
                        <!--                                                        </div>-->
                        <!--                                                    </div>-->

                        <!--                                                </div>-->
                        <!--                                            </div>-->
                        <!--                                        </PopoverPanel>-->
                        <!--                                    </transition>-->
                        <!--                                </Popover>-->
                        <!--                                <a v-for="page in navigation.pages" :key="page.name" :href="page.href"-->
                        <!--                                   class="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800">-->
                        <!--                                    {{ page.name }}-->
                        <!--                                </a>-->
                        <!--                            </div>-->
                        <!--                        </PopoverGroup>-->
                    </div>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
import { ref } from "vue";
import { Dialog, DialogPanel, Popover, PopoverButton, PopoverGroup, PopoverPanel, Tab, TabGroup, TabList, TabPanel, TabPanels, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { Link, usePage } from "@inertiajs/inertia-vue3";

export default {
    components: {
        Link,
        Dialog,
        DialogPanel,
        Popover,
        PopoverButton,
        PopoverGroup,
        PopoverPanel,
        Tab,
        TabGroup,
        TabList,
        TabPanel,
        TabPanels,
        TransitionChild,
        TransitionRoot
    },
    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        open: {
            type: Boolean,
            required: true,
            default: false
        },
        auth: Object,
        logoUrl: String,
        wishlist: Number,
        cart: Number
    },
    methods: {
        closeAfterSecond() {
            setTimeout(() => (this.open = false), 500);
        }
    },
    data() {
        return {
            show: true,
            open: false,
            navigation: {
                categories: [
                    {
                        id: "categories",
                        islogged: true,
                        name: "Kategoriler",
                        sections: [
                            [
                                // {
                                //     id: "discount",
                                //     name: "İndirimli Ürünler",
                                //     href: "/indirimli-urunler",
                                // },
                                {
                                    id: "discount",
                                    name: "İndirimli Ürünler",
                                    href: "/indirimli-urunler"
                                },
                                {
                                    id: "all-products",
                                    name: "Tüm Ürünler",
                                    href: "/kategoriler/tum-urunler"
                                },
                                {
                                    id: "momlap",
                                    name: "Ana Kucakları",
                                    href: "/kategoriler/ana-kucaklari",
                                    items: [
                                        { name: "Beşik", href: "/kategoriler/ana-kucaklari/besik" },
                                        { name: "Kanguru", href: "/kategoriler/ana-kucaklari/kanguru" }
                                    ]
                                },
                                {
                                    id: "babycar",
                                    name: "Bebek Arabaları",
                                    href: "/kategoriler/bebek-arabalari"
                                }
                            ],
                            [
                                {
                                    id: "babyhealthcare",
                                    name: "Bebek Bakım & Sağlık",
                                    href: "/kategoriler/bebek-bakim-amp-saglik"
                                },
                                {
                                    id: "nutrition",
                                    name: "Beslenme",
                                    href: "/kategoriler/beslenme"
                                },
                                {
                                    id: "vr",
                                    name: "Çocuk Teknolojisi",
                                    href: "/kategoriler/cocuk-teknolojisi"
                                },
                                {
                                    id: "homemachine",
                                    name: "Ev Gereçleri",
                                    href: "/kategoriler/ev-gerecleri"
                                }
                            ],
                            [
                                {
                                    id: "highchairs",
                                    name: "Mama Sandalyeleri",
                                    href: "/kategoriler/mama-sandalyeleri"
                                },
                                {
                                    id: "carchair",
                                    name: "Oto Koltuğu",
                                    href: "/kategoriler/oto-koltugu"
                                },
                                {
                                    id: "toys",
                                    name: "Oyun & Oyuncak",
                                    href: "/kategoriler/oyun-oyuncak"
                                },
                                {
                                    id: "travel",
                                    name: "Seyahat",
                                    href: "/kategoriler/seyahat"
                                },
                                {
                                    id: "sleeping",
                                    name: "Uyku",
                                    href: "/kategoriler/uyku"
                                }
                            ]
                        ]
                    },
                    {
                        id: "profile",
                        islogged: true,
                        name: "Hesabım",
                        sections: [
                            [
                                {
                                    id: "edit-profile",
                                    name: "Profilim",
                                    href: "/profili-duzenle",
                                    items: [
                                        { name: "Hesap Bilgilerim", href: "/profili-duzenle" },
                                        { name: "Şifre Değişikliği", href: "/sifremi-yenile" },
                                        { name: "İletişim Bilgilerim", href: "/iletisim-bilgileri" }
                                    ]
                                },
                                {
                                    id: "hirings",
                                    name: "Kiralamalarım",
                                    href: "/kiralamalar"
                                },
                                {
                                    id: "requests",
                                    name: "Destek Taleplerim",
                                    href: "/destek-taleplerim",
                                    items: [
                                        { name: "Geçmiş Taleplerim", href: "/gecmis-taleplerim" },
                                        { name: "Talep Oluştur", href: "/talep-olustur" }
                                    ]
                                },
                                {
                                    id: "addresses",
                                    name: "Adreslerim",
                                    href: "/adreslerim"
                                },
                                // {
                                //     id: "advice",
                                //     name: "Tavsiye Davetleri",
                                //     href: "/istek-listem-tavsiye"
                                // },
                                {
                                    id: "wishlist",
                                    name: "İstek Listem",
                                    href: "/istek-listem"
                                },
                                {
                                    id: "billing-type",
                                    name: "Ödeme Yöntemlerim",
                                    href: "/odeme-yontemlerim"
                                }
                            ]
                        ]
                    }
                ]
            }
        };
    }
};

const open = ref(false);
</script>
